import React from 'react'
import HeroCard from './hero-card'
import { ContentfulModules } from '../../helpers/modules'

const HeroCardCompound = props => {
  return (
    <HeroCard title={props.title} ctaText={props.ctaText}>
      <ContentfulModules modules={props.links} />
    </HeroCard>
  )
}

export default HeroCardCompound
